var chunkMapping = {
	"226": [
		4226
	],
	"266": [
		33,
		735,
		5195,
		5993
	],
	"504": [
		2504
	],
	"527": [
		2527
	],
	"542": [
		5542
	],
	"975": [
		6975
	]
};
var idToExternalAndNameMapping = {
	"33": [
		"default",
		"./mutationFeatures",
		6192
	],
	"735": [
		"default",
		"./handlers",
		2935
	],
	"2504": [
		"default",
		"./routes",
		3234
	],
	"2527": [
		"default",
		"./routes",
		6192
	],
	"4226": [
		"default",
		"./routes",
		6553
	],
	"5195": [
		"default",
		"./handlers",
		6553
	],
	"5542": [
		"default",
		"./routes",
		2935
	],
	"5993": [
		"default",
		"./handlers",
		3234
	],
	"6975": [
		"default",
		"./routes",
		8064
	]
};
var idToRemoteMap = {
	"33": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	],
	"735": [
		{
			"externalType": "script",
			"name": "companyApp"
		}
	],
	"2504": [
		{
			"externalType": "script",
			"name": "contribuitionApp"
		}
	],
	"2527": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	],
	"4226": [
		{
			"externalType": "script",
			"name": "personApp"
		}
	],
	"5195": [
		{
			"externalType": "script",
			"name": "personApp"
		}
	],
	"5542": [
		{
			"externalType": "script",
			"name": "companyApp"
		}
	],
	"5993": [
		{
			"externalType": "script",
			"name": "contribuitionApp"
		}
	],
	"6975": [
		{
			"externalType": "script",
			"name": "inboxApp"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"33": {
		"shareScope": "default",
		"name": "./mutationFeatures",
		"externalModuleId": 6192,
		"remoteName": "mutationsApp"
	},
	"735": {
		"shareScope": "default",
		"name": "./handlers",
		"externalModuleId": 2935,
		"remoteName": "companyApp"
	},
	"2504": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 3234,
		"remoteName": "contribuitionApp"
	},
	"2527": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 6192,
		"remoteName": "mutationsApp"
	},
	"4226": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 6553,
		"remoteName": "personApp"
	},
	"5195": {
		"shareScope": "default",
		"name": "./handlers",
		"externalModuleId": 6553,
		"remoteName": "personApp"
	},
	"5542": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 2935,
		"remoteName": "companyApp"
	},
	"5993": {
		"shareScope": "default",
		"name": "./handlers",
		"externalModuleId": 3234,
		"remoteName": "contribuitionApp"
	},
	"6975": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 8064,
		"remoteName": "inboxApp"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}